<template>
  <div class="main">
    <v-row class="d-flex justify-center">
      <v-col
        cols="11"
        sm="8"
        class="main"
        :class="{
          'mb-16': !!footer,
        }"
      >
        <div class="header">
          <span class="title">
            {{ stageTitle }}
          </span>
          <span class="subtitle">
            {{ stageSubTitle }}
          </span>
        </div>
        <div class="content">
          <slot />
        </div>
        <div
          v-if="showValidation"
          class="footer"
        >
          <v-checkbox
            v-model="internalValid"
            on-icon="done"
            off-icon=""
            color="#009ee0"
            :label="$t('subscription.certify-infos')"
            class="checkbox my-1 mr-2 button-purple ml-6"
            elevation="0"
          />
        </div>
      </v-col>
    </v-row>
    <v-row
      v-if="footer"
      class="d-flex-column justify-center"
    >
      <div class="copyright">
        {{ $t('subscription.copyright') }} <span class="bold">{{ $t('subscription.company') }}</span>
      </div>
    </v-row>
  </div>
</template>

<script>
  export default {
    props: {
      stageTitle: {
        type: String,
        required: true,
      },
      stageSubTitle: {
        type: String,
        required: true,
      },
      footer: {
        type: Boolean,
        default: false,
      },
      validation: {
        type: Boolean,
        default: false,
      },
      showValidation: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      internalValid: {
        get() {
          return this.validation
        },
        set(value) {
          return this.$emit('update:validation', value)
        },
      },
    },
  }
</script>

<style lang="scss" scoped>
.main {
  margin-top: 2rem;
  .main {
    padding: unset;
    // padding: 2rem;
    border-radius: 8px;
    background-color: $color-ffffff;
    box-shadow: 0 4px 8px 0 $color-31_54_139_08;
    .header {
      margin: 2rem 2rem 1rem 2rem;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid rgba(158, 159, 162, 0.32);
      padding-bottom: 2rem;
      .title {
        color: $color-001c4b;
        font-size: 1.4rem;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 2rem;
      }
      .subtitle {
        color: $color-4d4d4f;
        font-size: 1rem;
        font-weight: 500;
        letter-spacing: 0.24px;
        line-height: 1.4rem;
      }
    }
    .content {
      padding: 0 2rem 0 2rem;
    }
    .footer {
      padding: 1rem;
      border-radius: 0 0 8px 8px;
      background-color: $color-fafbff;
      box-shadow: inset 0 1px 0 0 rgba(121, 137, 183, 0.16);
    }
  }
  .copyright {
    margin-bottom: 2.8rem;
    color: $color-b4bad2;
    font-size: 1rem;
    .bold {
      font-weight: bold;
    }
  }
}
</style>
